import React, { useState } from "react";
import { TextField, MenuItem, Button } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const RecentTransactions = ({ transactions }) => {

  // console.log("transactions on recent transaction page ",transactions);
  
  const [dateFilter, setDateFilter] = useState("all");
  const [bankFilter, setBankFilter] = useState("all");
  const [amountFilter, setAmountFilter] = useState("all");
  const [showAll, setShowAll] = useState(false);

  const banks = [...new Set(transactions.map((t) => t.bank))];

  const filteredTransactions = transactions.filter((t) => {
    if (bankFilter !== "all" && t.bank !== bankFilter) return false;
    if (amountFilter === "low" && t.amount > 25000) return false;
    if (amountFilter === "medium" && (t.amount <= 25000 || t.amount > 50000))
      return false;
    if (amountFilter === "high" && t.amount <= 50000) return false;
    return true;
  });

  const VISIBLE_COUNT = 5;

  const visibleTransactions = showAll
    ? filteredTransactions[0]?.schedules || []
    : filteredTransactions[0]?.schedules?.slice(0, VISIBLE_COUNT)|| [];

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);

  const getStatusStyle = (status) => {
    if (status === "Success") return { bg: "#E8F5E9", color: "#2E7D32" };
    if (status === "Pending") return { bg: "#E3F2FD", color: "#1565C0" };
    return { bg: "#FDECEA", color: "#D32F2F" };
  };

  const formatDateDDMMYYYY = (isoDate) => {
    if (!isoDate) return "";

    const date = new Date(isoDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const AccountNumber = transactions[0]?.mandate?.bankDetails?.accountNumber || "na";
   const bankName = transactions[0]?.mandate?.bankDetails?.bankName || "bank name ";
  // console.log("Bank account number ", AccountNumber);

   const handleToggle = () => {
    setShowAll((prev) => !prev);  // Toggle the showAll state on click
  };
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 20,
        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
        marginBottom: 24,
        width: "100%",
        overflow: "hidden",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #E0E0E0",
          paddingBottom: 12,
          marginBottom: 16,
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ReceiptLongIcon  sx={{
      color: "#1976D2",
      fontSize: "2rem", // Default size for larger screens
      "@media (max-width: 768px)": {
        fontSize: "2.5rem", // Larger size for mobile
      },
    }} />
          <span style={{ fontSize: 16, fontWeight: 600 }}>
            Recent Mandate Transactions
          </span>
        </div>

        <Button
          variant="text"
          size="small"
             onClick={handleToggle}
          sx={{ textTransform: "none", color: "#1565C0", fontSize: "10px" , fontWeight: 600}}
        >
          {showAll ? "Show Less" : "View All"}
        </Button>
      </div>

      {/* FILTERS */}
      {/* <div
        style={{
          display: "flex",
          gap: 16,
          marginBottom: 16,
          flexWrap: "wrap",
        }}
      >
        <TextField
          select
          size="small"
          label="Date Range"
          value={dateFilter}
          sx={{
            minWidth: 160,
            "& .MuiInputLabel-root": {
              fontSize: "13px",
               fontWeight: 600 // Increase the label font size here
            },
            "& .MuiInputBase-input": {
              fontSize: "10px", // Increase the input font size here
            },
          }}
        >
          <MenuItem value="all">All Time</MenuItem>
          <MenuItem value="7days">Last 7 Days</MenuItem>
          <MenuItem value="30days">Last 30 Days</MenuItem>
          <MenuItem value="90days">Last 90 Days</MenuItem>
        </TextField>

        <TextField
          select
          size="small"
          label="Bank"
          value={bankFilter}
          sx={{
            minWidth: 160,
            "& .MuiInputLabel-root": {
              fontSize: "13px",
              fontWeight: 600 // Increase the label font size here
            },
            "& .MuiInputBase-input": {
              fontSize: "10px", // Increase the input font size here
            },
          }}
        >
          <MenuItem value="all">All Banks</MenuItem>
          {banks.map((bank) => (
            <MenuItem key={bank} value={bank}>
              {bank}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          size="small"
          label="Amount"
          value={amountFilter}
          sx={{
            minWidth: 160,
            "& .MuiInputLabel-root": {
              fontSize: "13px",
               fontWeight: 600 // Increase the label font size here
            },
            "& .MuiInputBase-input": {
              fontSize: "10px", // Increase the input font size here
            },
          }}
        >
          <MenuItem value="all">All Amounts</MenuItem>
          <MenuItem value="low">Below ₹25,000</MenuItem>
          <MenuItem value="medium">₹25,000 - ₹50,000</MenuItem>
          <MenuItem value="high">Above ₹50,000</MenuItem>
        </TextField>
      </div> */}

      {/* DESKTOP TABLE */}
    <div className="desktop-table">
  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
    <thead>
      <tr style={{ background: "#F7F7F7" }}>
        {[
          "Transaction ID",
          "Amount",
          "Date",
          "Bank Account",
          "Status",
        ].map((h) => (
          <th
            key={h}
            style={{
              textAlign: "left",
              padding: 12,
              fontSize: 12,
              color: "#757575",
            }}
          >
            {h.toUpperCase()}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {/* Check if there are any transactions to display */}
      {visibleTransactions?.length > 0 ? (
        visibleTransactions
          .filter((txn) => txn?.execution?.transactionUniqueId)
          .map((txn) => {
            // console.log("transaction status", txn);

            const s = getStatusStyle(txn.status);
            return (
              <tr
                key={txn.execution?.transactionUniqueId}
                style={{ borderBottom: "1px solid #E0E0E0" }}
              >
                <td style={{ padding: 14, fontFamily: "monospace" }}>
                  {txn?.execution?.transactionUniqueId || "N/A"}
                </td>
                <td style={{ padding: 14, color: "#D32F2F", fontWeight: 600 }}>
                  {formatCurrency(txn?.amount || 0)}
                </td>
                <td style={{ padding: 14 }}>
                  {formatDateDDMMYYYY(txn?.execution?.executedAt)}
                </td>
                <td style={{ padding: 14 }}>
                  {bankName} 
                  <div style={{ fontSize: 12, color: "#757575" }}>
                    ****{AccountNumber?.slice(-4)}
                  </div>
                </td>
                <td style={{ padding: 14 }}>
                  <span
                    style={{
                      background: s.bg,
                      color: s.color,
                      padding: "4px 12px",
                      borderRadius: 14,
                      fontSize: 12,
                      fontWeight: 600,
                    }}
                  >
                    {txn?.status}
                  </span>
                </td>
              </tr>
            );
          })
      ) : (
        <tr>
          <td
            colSpan="5"
            style={{
              padding: 14,
              textAlign: "center",
              color: "#757575",
            }}
          >
            No recent transactions
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>


     
      {/* MOBILE LIST */}
  {/* MOBILE LIST */}
<div className="mobile-list">
  {visibleTransactions?.length > 0 ? (
    visibleTransactions
      .filter((txn) => txn?.execution?.transactionUniqueId)
      .map((txn) => {
        // console.log("transaction status", txn);

        const s = getStatusStyle(txn.status);
        return (
          <div
            key={txn.execution?.transactionUniqueId}
            style={{
              background: "#F7F7F7",
              borderRadius: 10,
              padding: 14,
              marginBottom: 12,
              display: "flex",
              flexDirection: "column", // Align items vertically for mobile view
              gap: 12,
            }}
          >
            <div style={{ fontWeight: 600, fontSize: 14 }}>
             {" Transaction ID: "}{txn?.execution?.transactionUniqueId || "N/A"}  
            </div>
            <div style={{ margin: "6px 0", color: "#D32F2F", fontWeight: 600, fontSize: 14 }}>
              {"Amount: "}{formatCurrency(txn?.amount || 0)}
            </div>
            <div style={{ fontSize: 13, color: "#757575" }}>
              {"Date: "}{formatDateDDMMYYYY(txn?.execution?.executedAt) || "N/A"}
            </div>
            <div style={{ fontSize: 13, marginTop: 6 }}>
            {bankName} <br/>
              <span> ****{AccountNumber?.slice(-4)}</span>
            </div>
            <span
              style={{
                display: "inline-block",
                marginTop: 8,
                background: s.bg,
                color: s.color,
                padding: "4px 12px",
                borderRadius: 14,
                fontSize: 12,
                fontWeight: 600,
                width:70
              }}
            >
              {txn?.status}
            </span>
          </div>
        );
      })
  ) : (
    <div
      style={{
        padding: 14,
        textAlign: "center",
        color: "#757575",
        fontSize: 14,
      }}
    >
      No recent transactions
    </div>
  )}
</div>

{/* RESPONSIVE RULES */}
<style>{`
  /* DEFAULT: DESKTOP */
  .desktop-table { display: block; }
  .mobile-list { display: none; }

  /* MOBILE */
  @media (max-width: 768px) {
    .desktop-table { display: none; }
    .mobile-list { display: block; }
  }

  @media (max-width: 600px) {
    .mobile-list {
      font-size: 12px;
    }
  }
`}</style>


    </div>
  );
};
export default RecentTransactions;
